import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/unidades/getIngresosTotalesUnidad.php';

export default function getIngresosTotalesUnidad({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}